import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "material-symbols-outlined icon-class pr-3" }
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex align-items-center cursor-pointer p-3 border-round transition-duration-150 transition-colors p-ripple" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_navlink = _resolveComponent("navlink", true)!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_styleclass = _resolveDirective("styleclass")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.subMenus)
      ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
          _createVNode(_component_router_link, {
            to: _ctx.link,
            class: "flex align-items-center cursor-pointer p-3 border-round navtext hover:navtexthover transition-duration-150 transition-colors p-ripple sidebar-link-app parent-link",
            id: _ctx.link,
            append: "",
            exact: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.icon), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }, 8, ["to", "id"])
        ]))
      : (_openBlock(), _createElementBlock("li", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [
            _createElementVNode("i", {
              class: _normalizeClass(["pi mr-2", _ctx.icon])
            }, null, 2),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "pi pi-chevron-down ml-auto" }, null, -1))
          ])), [
            [_directive_ripple],
            [_directive_styleclass, {
                    selector: '@next',
                    enterClass: 'hidden',
                    enterActiveClass: 'slidedown',
                    leaveToClass: 'hidden',
                    leaveActiveClass: 'slideup'
                }]
          ]),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subMenus, (subMenu, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_component_navlink, {
                  title: subMenu.title,
                  link: subMenu.link,
                  icon_type: subMenu.icon_type,
                  icon: subMenu.icon,
                  subMenus: subMenu.subMenus,
                  showmenu: _ctx.showmenu,
                  isOpen: _ctx.isOpen
                }, null, 8, ["title", "link", "icon_type", "icon", "subMenus", "showmenu", "isOpen"])
              ]))
            }), 128))
          ])
        ]))
  ]))
}